/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Show_Identified_Vehicles_Panel_LabelInputs */

const fr_settings_show_identified_vehicles_panel_label = /** @type {(inputs: Settings_Show_Identified_Vehicles_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau des véhicules identifiés`)
};

const en_settings_show_identified_vehicles_panel_label = /** @type {(inputs: Settings_Show_Identified_Vehicles_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identified vehicles table`)
};

/**
* | output |
* | --- |
* | "Identified vehicles table" |
*
* @param {Settings_Show_Identified_Vehicles_Panel_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_show_identified_vehicles_panel_label = /** @type {((inputs?: Settings_Show_Identified_Vehicles_Panel_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Show_Identified_Vehicles_Panel_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_show_identified_vehicles_panel_label(inputs)
	return en_settings_show_identified_vehicles_panel_label(inputs)
});